import './App.css';
import React, { useState } from 'react';
import resume from './assets/pdf/Haja Sarbudeen-Resume.pdf';
import html5 from './assets/img/html5.png';
import css3 from './assets/img/css3.png';
import javascript from './assets/img/js.png';
import jquery from './assets/img/jquery.png';
import core_php from './assets/img/core_php.png';
import mysql from './assets/img/mysql.png';
import reactjs from './assets/img/reactjs.png';
import laravel from './assets/img/laravel.png';
import tailwindcss from './assets/img/tailwindcss.png';
import bootstrap from './assets/img/bootstrap.png';
import wordpress from './assets/img/wordpress.png';
import shopify from './assets/img/shopify.png';
import figma from './assets/img/figma.png';
import photoshop from './assets/img/photoshop.png';
import illustrator from './assets/img/illustrator.png';
import docker from './assets/img/docker.png';
import github from './assets/img/github.png';
import bararityres from './assets/img/bararityres.jpg';
import makita from './assets/img/makita.jpg';
import zentroa from './assets/img/zentroa.jpg';
import integres from './assets/img/integres.jpg';
import qmax from './assets/img/qmax.jpg';
import safinaas from './assets/img/safinaas.jpg';
import alchemist from './assets/img/alchemizt.jpg';
import bibmac from './assets/img/bibmac.jpg';
import burjbabil from './assets/img/burjbabil.jpg';
import eiv from './assets/img/eiv.jpg';
import nxthorizon from './assets/img/nxthorizon.jpg';
import prime from './assets/img/prime-property-surveys.jpg';
import waverfurniture from './assets/img/waverfurniture.jpg';
import zpisolutions from './assets/img/zpi-solutions.jpg';
import projotech from './assets/img/projotech.jpg';

function App() {

  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  }

  return (
    <div className="App">
      <header>
        <div className='container mx-auto grid grid-cols-6'>
          <div className='logo col-span-1'>
            <h2>sarbudeen<span>.com</span></h2>
          </div>
          <div className='col-span-4 w-full'>
          </div>
          <div className='col-span-1 icon-box'>
            <button className="nav-icon" onClick={toggleSidebar}>
              <i className='fa-solid fa-bars'></i>
            </button>
          </div>
        </div>
      </header>

      <main>
        {isOpen && (
          <div className='main-menu'>
            <div className='container'>
              <div className='top-section mx-auto grid grid-cols-6'>
                <div className='logo col-span-1 w-full'>
                  <h2 className='nav-logo'>sarbudeen<span>.com</span></h2>
                </div>
                <div className='col-span-4 w-full'>
                </div>
                <div className='col-span-1 icon-box'>
                  <button className="close-icon" onClick={toggleSidebar}>
                    <i className='fa-solid fa-times'></i>
                  </button>
                </div>
              </div>
              <div className='bottom-section mx-auto grid grid-cols-1 md:grid-cols-6'>
                <div className='nav col-span-1 md:col-span-3'>
                  <ul>
                    <li><a href='#about' onClick={toggleSidebar}>About me</a></li>
                    <li><a href='#experience' onClick={toggleSidebar}>Experience</a></li>
                    <li><a href='#education' onClick={toggleSidebar}>Education</a></li>
                    <li><a href='#skills' onClick={toggleSidebar}>Skills</a></li>
                    <li><a href='#works' onClick={toggleSidebar}>my Works</a></li>
                    <li><a href='#contact' onClick={toggleSidebar}>Contact me</a></li>
                  </ul>
                </div>
                <div className='social-icons col-span-1 md:col-span-3'>
                  <ul>
                    <li><a href='tel:+971569292445'>+971 569 292445</a></li>
                    <li><a href='mailto:haja@sarbudeen.com'>haja@sarbudeen.com</a></li>
                    <li>Dubai, United Arab Emirates</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className='container mx-auto grid grid-cols-6'>
          <div className='hero col-span-6'>
            <h3>Hi I'm</h3>
            <h1>Haja <span>Sarbudeen.</span></h1>
            <h2 className='subtitle'>A <span>Full Stack Web Developer</span> based in Dubai, UAE.</h2>
            <p>Crafting seamless digital solutions for over <span>6+ years</span>, I specialize in scalable websites and applications using PHP, JavaScript, MySQL, and modern frameworks like Tailwind CSS. <span>Currently advancing my skills in Laravel and React.js</span>, I'm passionate about innovation and delivering impactful web experiences.</p>

            <div className='social'>
              <ul>
                <li><a href="https://linkedin.com/in/sarbudeen" target='_blank'  rel="noreferrer"><i class="fa-brands fa-linkedin-in"></i> <label>Linked in</label></a></li>
                <li><a href="https://github.com/sarbudeenmca" target='_blank'  rel="noreferrer"><i class="fa-brands fa-github"></i> <label>Github</label></a></li>
                <li><a href="mailto:haja@sarbudeen.com"><i class="fa-regular fa-envelope"></i> <label>haja@sarbudeen.com</label></a></li>
                <li><a href="tel:+971569292445"><i class="fa-solid fa-phone small"></i> <label>+971 56 9292 445</label></a></li>
              </ul>
              <button className='download'><a href={resume} target='_blank'  rel="noreferrer">View Resume</a></button>
            </div>
          </div>

          <div className='col-span-6'>
            <div id='about' className='about grid grid-cols-12'>
              <div className='left col-span-12 md:col-span-8 lg:col-span-9'>
                <h2 className='title'>About us.</h2>
                <p>As a Full Stack Developer with 6+ years of experience, I specialize in creating impactful web solutions with a focus on seamless user experiences. I developed a robust e-commerce platform handling 4,000+ daily users <a href="#">www.makita.ae</a> and implemented SEO-friendly architecture that drove a 30% growth in organic traffic <a href="#">www.zentroa.com</a>.</p>

                <p>Currently enhancing my skills in Laravel and React.js, I thrive on tackling challenges and turning ideas into innovative applications. Based in Dubai, I'm dedicated to evolving with the fast-paced world of web development.</p>
              </div>
              <div className='right col-span-12 md:col-span-4 lg:col-span-3'>
                <h3>Personal Details.</h3>
                <div className="grid md:grid-cols-1 grid-cols-2 gap-x-5 gap-y-3 md:gap-y-0">
                  <h5><small className="block">Visa Status</small> Employment</h5>
                  <h5><small className="block">Current Location</small> Dubai,</h5>
                  <h5><small className="block">Driving License</small> Available - UAE.</h5>
                  <h5><small className="block">Languages Known</small> Tamil, English</h5>
                </div>
              </div>
            </div>
          </div>

          <div className='col-span-6'>
            <div id='experience' className='experience grid grid-cols-6'>
              <div className='col-span-6'>
                <h2 className='title md:pb-0 pb-6'>Experience.</h2>

                <div className='exp-container'>
                  <h3>SEP 2021 - Present</h3>
                  <h4>Visual Lab LLC | <small><span>Dubai,</span> <label className='md:inline-block hidden'>United Arab Emirates</label> <label className='md:hidden inline-block'>UAE.</label></small></h4>
                  <h6>Senior Web Developer</h6>
                  <p>Managed the maintenance and optimization of over 30 websites, focusing on improving page speed and SEO rankings. Developed and maintained 5+ web-based applications, including inventory management systems, custom CRMs, and event planning tools. Led server maintenance efforts to ensure seamless application performance, implementing robust security protocols to safeguard data and functionality.</p>
                </div>

                <div className='exp-container'>
                  <h3>SEP 2020 - SEP 2021</h3>
                  <h4>Zentroa Technologies | <small><span>Dubai,</span>  <label className='md:inline-block hidden'>United Arab Emirates</label> <label className='md:hidden inline-block'>UAE.</label></small></h4>
                  <h6>Full-Stack Web Developer</h6>
                  <p>Developed a custom CRM application to enhance client management and productivity. Designed and deployed high-performance, SEO-optimized WordPress and WooCommerce websites. Managed and maintained web hosting servers, ensuring 99% uptime for seamless operations.</p>
                </div>

                <div className='exp-container'>
                  <h3>JUL 2018 - OCT 2020</h3>
                  <h4>Sherta General Maintenance LLC | <small><span>Abu Dhabi,</span> <label className='md:inline-block hidden'>United Arab Emirates</label> <label className='md:hidden inline-block'>UAE.</label></small></h4>
                  <h6>Full-Stack Web Developer</h6>
                  <p>Designed and developed a custom ERP application with an accounts module, automating workflows to boost operational efficiency by 40%. Automated work order processing, timesheet management, and customer report generation through mobile-friendly interfaces, enhancing accessibility and reducing manual effort. Implemented secure, scalable database solutions using PHP and MySQL to meet growing business needs.</p>
                </div>

              </div>
            </div>
          </div>

          <div className='col-span-6'>
            <div id='education' className='education grid grid-cols-6'>
              <div className='col-span-6'>
                <h2 className='title'>Education.</h2>
                <div className='edu-container grid grid-cols-6'>

                  <div className='md:col-span-3 col-span-6 edu'>
                    <h3>2015 - 2017</h3>
                    <h2>MCA <span className='md:inline hidden'>|</span> <small>Master of Computer Application</small></h2>
                    <h4><span>Jamal Mohamed College,</span> Trichy, India</h4>
                    <h6>Projects Done</h6>
                    <p>Developed and implemented a College Staff Feedback Management System, eliminating paperwork for 20+ departments by streamlining student feedback collection and automated report generation.</p>
                  </div>

                  <div className='md:col-span-3 col-span-6 edu md:mt-0 mt-8'>
                    <h3>2012 - 2015</h3>
                    <h2>B.Sc <span className='md:inline hidden'>|</span> <small>Bachelor of Computer Science</small></h2>
                    <h4><span>Jamal Mohamed College,</span> Trichy, India</h4>
                    <h6>Certifications</h6>
                    <p>Web Development & Advanced Java Programing.</p>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className='col-span-6'>
            <div id='skills' className='skills grid grid-cols-6'>
              <div className='col-span-6'>
                <h2 className='title'>Skills.</h2>
                <div className='skills-container'>
                  <div className='grid grid-cols-3 md:grid-cols-8'>
                    <div className='col-span-3 md:col-span-2 logo-title'>
                      <p>Web<br className='hidden md:block'/> Development</p>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={html5} alt='html5 logo' />
                      <label>HTML5</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={css3} alt='css3 logo' />
                      <label>CSS3</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={javascript} alt='javascript logo' />
                      <label>Java Script</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={jquery} alt='jquery logo' />
                      <label>jQuery</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img className='pt-3' src={core_php} alt='core_php logo' />
                      <label>Core PHP</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img className='pt-3' src={mysql} alt='MySql logo' />
                      <label>MySql</label>
                    </div>
                  </div>

                  <div className='grid grid-cols-3 md:grid-cols-8 mt-6 md:mt-10'>
                    <div className='col-span-3 md:col-span-2 logo-title'>
                      <p>Frameworks<br className='hidden md:block'/> & Libraries</p>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={reactjs} alt='React Js logo' />
                      <label>React Js</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={laravel} alt='laravel logo' />
                      <label>Laravel</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={tailwindcss} alt='Tailwind css logo' />
                      <label>Tailwind css</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={bootstrap} alt='Bootstrap logo' />
                      <label>Bootstrap</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={wordpress} alt='Wordpress logo' />
                      <label>Wordpress</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={shopify} alt='shopify logo' />
                      <label>Shopify</label>
                    </div>
                  </div>

                  <div className='grid grid-cols-3 md:grid-cols-8 mt-6 md:mt-10'>
                    <div className='col-span-3 md:col-span-2 logo-title'>
                      <p>Creative &<br className='hidden md:block'/> Dev skills</p>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={figma} alt='figma logo' />
                      <label>Figma</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={photoshop} alt='Photoshop logo' />
                      <label>Photoshop</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={illustrator} alt='Illustrator logo' />
                      <label>Illustrator</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={docker} alt='Docker logo' />
                      <label>Docker</label>
                    </div>
                    <div className='col-span-1 logo-box'>
                      <img src={github} alt='Github logo' />
                      <label>Github</label>
                    </div>
                    <div className='col-span-1 logo-box'>

                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>

          <div className='col-span-6'>
            <div id='works' className='works grid grid-cols-6'>
              <div className='col-span-6'>
                <h2 className='title'>My works.</h2>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-5'>

                  <div className='col-span-1 work'>
                    <img src={zentroa} alt='zentroa mockup' className='border-[#c03d4d]' />
                    <div className='content'>
                      <h2>Zentroa Technologies</h2>
                      <h3>Custom Design <span>SEO</span></h3>
                    </div>
                    <a href="https://zentroa.com" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  <div className='col-span-1 work'>
                    <img src={makita} alt='makita mockup' className='border-[#47abca]' />
                    <div className='content'>
                      <h2>Makita Gulf</h2>
                      <h3>Design <span>Development</span></h3>
                    </div>
                    <a href="https://makita.ae" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  
                  <div className='col-span-1 work'>
                    <img src={alchemist} alt='Alchemizt mockup' className='border-[#444]' />
                    <div className='content'>
                      <h2>Alchemizt Interiors</h2>
                      <h3>Shopify</h3>
                    </div>
                    <a href="https://alchemizt.ae" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>
                  

 <div className='col-span-1 work'>
                    <img src={bararityres} alt='barari mockup' className='border-[#5c9637]' />
                    <div className='content'>
                      <h2>Barari Tyres</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://bararityres.com" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  <div className='col-span-1 work'>
                    <img src={prime} alt='Prime Property mockup' className='border-[#8C2E2F]' />
                    <div className='content'>
                      <h2>Prime Property</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://primepropertysurveys.co.uk" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>
                  

                  <div className='col-span-1 work'>
                    <img src={eiv} alt='East Indigo mockup' className='border-[#3C2C4F]' />
                    <div className='content'>
                      <h2>East Indigo</h2>
                      <h3>Custom Design</h3>
                    </div>
                      <a href="https://eastindigoventures.com" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

  <div className='col-span-1 work'>
                    <img src={waverfurniture} alt='Waver Furniture mockup' className='border-[#444]' />
                    <div className='content'>
                      <h2>Waver Furniture</h2>
                      <h3>Custom Design</h3>
                    </div>
                      <a href="https://waverfurniture.com" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  <div className='col-span-1 work'>
                    <img src={bibmac} alt='Bibmac mockup' className='border-[#32275C]' />
                    <div className='content'>
                      <h2>Bibmac</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://bibmac.ae" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>
                 
  <div className='col-span-1 work'>
                    <img src={projotech} alt='Projotech mockup' className='border-[#444]' />
                    <div className='content'>
                      <h2>Projotech</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://school.projotech.com/" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  <div className='col-span-1 work'>
                    <img src={zpisolutions} alt='ZPI Solutions mockup' className='border-[#314B64]' />
                    <div className='content'>
                      <h2>ZPI Solutions</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://exhibitv.tech/zpisolutions/" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>
                  
                  <div className='col-span-1 work'>
                    <img src={nxthorizon} alt='Next Horizon mockup' className='border-[#22219F]' />
                    <div className='content'>
                      <h2>Next Horizon</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://nxthorizon.ai" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>
                 
                  <div className='col-span-1 work'>
                    <img src={safinaas} alt='Safinaas mockup' className='border-[#2A2B68]' />
                    <div className='content'>
                      <h2>Safinaas Group</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://safinaas.com" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                     <div className='col-span-1 work'>
                    <img src={integres} alt='integres mockup' className='border-[#23A6EA]' />
                    <div className='content'>
                      <h2>Integres</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://integres.net" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  <div className='col-span-1 work'>
                    <img src={qmax} alt='Qmax mockup' className='border-[#B21419]' />
                    <div className='content'>
                      <h2>Qmax</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://q-max.cc" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>

                  
                  <div className='col-span-1 work'>
                    <img src={burjbabil} alt='Burj Babil mockup' className='border-[#286414]' />
                    <div className='content'>
                      <h2>Burj Babil</h2>
                      <h3>Custom Design</h3>
                    </div>
                    <a href="https://burjbabils.com/" target="_blank" rel="noreferrer" className='button'>Visit Site <i class="fa-solid fa-arrow-right"></i></a>
                  </div>
                  
                

                </div>
              </div>
            </div>
          </div>

        </div>

        <div className='col-span-6'>
          <div id='ribbon' className='ribbon grid grid-cols-6'>
            <div className='dark-ribbon col-span-6'>
              <ul>
                <li>React js</li>
                <li>Shopify</li>
                <li>Docker</li>
                <li>Web Development</li>
                <li>Github</li>
                <li>Laravel</li>
                <li>Figma</li>
                <li>MySql</li>
                <li>Photoshop</li>
              </ul>

              <ul>
                <li>React js</li>
                <li>Shopify</li>
                <li>Docker</li>
                <li>Web Development</li>
                <li>Github</li>
                <li>Laravel</li>
                <li>Figma</li>
                <li>MySql</li>
                <li>Photoshop</li>
              </ul>
            </div>

            <div className='primary-ribbon col-span-12'>
              <ul>
                <li>Github</li>
                <li>React js</li>
                <li>Java Script</li>
                <li>Figma</li>
                <li>Shopify</li>
                <li>Wordpress</li>
                <li>CRM Development</li>
                <li>Illustrator</li>
                <li>SEO</li>
              </ul>

              <ul>
                <li>Github</li>
                <li>React js</li>
                <li>Java Script</li>
                <li>Figma</li>
                <li>Shopify</li>
                <li>Wordpress</li>
                <li>CRM Development</li>
                <li>Illustrator</li>
                <li>SEO</li>
              </ul>
            </div>
          </div>
        </div>

        <div className='container mx-auto grid grid-cols-12'>
          <div className='col-span-12'>
            <div id='contact' className='contact-container'>
              <h2 className='title'>Contact.</h2>
              <p>Have a question or want to collaborate? Feel free to reach out! Whether it's a project, feedback, or just to say hello, I'm here to connect. Let's make something amazing together!</p>
              <div className='contact-links grid grid-cols-1 md:grid-cols-3'>
                <div className='link col-span-1'>
                  <h3><i className='fa-solid fa-phone'></i> Mobile Number</h3>
                  <a href="tel:+971569292445">+971 569 292445</a>
                </div>
                <div className='link col-span-1'>
                  <h3><i className='fa-regular fa-envelope'></i> Email Address</h3>
                  <a href="mailto:haja@sarbudeen.com">haja@<span>sarbudeen.com</span></a>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className='col-span-12'>
          <div className='footer'>
            <p>© 2025 sarbudeen. All rights reserved.</p>
          </div>
        </div>

      </main>

    </div>
  );
}

export default App;
